module.exports = __webpack_public_path__ + "static/media/LandingPage-Xchange-MouseOver.84fb9c63.png";